import { openingCentre } from './siteGeometry.js';
import { ptInPoly } from './geometry.js';

/** Only infer entering/leaving where exactly one side is inside a building.
 * Internal doorways retain explicit arrow-relative language. */
export function entryDirectionOptions(S, openingId) {
  const o = S.openings.find(o => o.id === openingId), p = o && openingCentre(S, o);
  if (!p) return [['forward', 'Along the arrow'], ['reverse', 'Against the arrow'], ['both', 'Both directions']];
  const a = p.heading * Math.PI / 180;
  const indoor = sign => S.areas.some(area => area.kind === 'floor' && area.environment !== 'outdoor' && ptInPoly(p.x + Math.cos(a) * .7 * sign, p.y + Math.sin(a) * .7 * sign, area.pts));
  const forward = indoor(1), reverse = indoor(-1);
  return [['forward', forward !== reverse ? forward ? 'Entering building · along arrow' : 'Leaving building · along arrow' : 'Along the arrow'], ['reverse', forward !== reverse ? reverse ? 'Entering building · against arrow' : 'Leaving building · against arrow' : 'Against the arrow'], ['both', 'Both directions']];
}
